import { h as head, e as escape_html, c as attr_class, b as attr, f as clsx, p as pop, a as push } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { e as eyeSlash } from "../../../../chunks/icons.js";
import { h as html } from "../../../../chunks/html.js";
function _page($$payload, $$props) {
  push();
  const { form } = $$props;
  let email = form?.data?.email;
  let password = "";
  let rememberMe = false;
  let formErrors = form?.errors || {};
  const getFieldError = (field) => {
    return formErrors[field]?.[0] || "";
  };
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Login</title>`;
  });
  $$payload.out.push(`<h2 class="text-center text-2xl font-bold">Login</h2> <form class="mt-4 space-y-4" method="POST">`);
  if (formErrors._errors) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="mb-4 rounded-md bg-red-50 p-4" role="alert"><p class="text-sm text-red-700">${escape_html(formErrors._errors[0])}</p></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div><label for="email" class="block text-sm font-semibold">Email</label> <input type="email" id="email" name="email" autocomplete="username"${attr_class(
    clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!getFieldError("email")
    }),
    "svelte-m1xxe0"
  )}${attr("value", email)}${attr("aria-invalid", !!getFieldError("email"))}${attr("aria-describedby", getFieldError("email") ? "email-error" : void 0)} required/> `);
  if (getFieldError("email")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p id="email-error" class="mt-1 text-xs text-red-500">${escape_html(getFieldError("email"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div> <div class="group relative"><label for="password" class="block text-sm font-semibold">Password</label> <input${attr("type", "password")} id="password" name="password" autocomplete="current-password"${attr_class(
    clsx({
      "focus:border-primary w-full rounded-md border-2 border-black p-2 focus:outline-none": true,
      "border-red-500": !!getFieldError("password")
    }),
    "svelte-m1xxe0"
  )}${attr("value", password)}${attr("aria-invalid", !!getFieldError("password"))}${attr("aria-describedby", getFieldError("password") ? "password-error" : void 0)} required/> `);
  if (getFieldError("password")) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p id="password-error" class="mt-1 text-xs text-red-500">${escape_html(getFieldError("password"))}</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <button type="button" class="absolute top-7 right-3 text-xs text-gray-700" tabindex="-1">`);
  {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`${html(eyeSlash)}`);
  }
  $$payload.out.push(`<!--]--></button></div> <div class="flex items-center"><input type="checkbox" id="rememberMe" name="rememberMe" class="h-4 w-4 rounded border-gray-400"${attr("checked", rememberMe, true)}/> <label for="rememberMe" class="ml-2 block text-sm text-gray-900">Remember me</label></div> <button type="submit" class="group bg-primary hover:bg-primary/90 flex w-full items-center justify-center rounded-md border p-2 text-white transition-colors hover:cursor-pointer">`);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> Login</button> <div class="text-primary mt-3 flex justify-between text-xs"><div>If you don't have an account, <a href="/register" class="hover:underline">Register</a></div> <a href="/forgotPassword" class="transition-colors hover:underline">Forgot Password</a></div></form>`);
  pop();
}
export {
  _page as default
};
